import { computed, action } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { ILinksConfiguration } from '../models';
import { ILinkProps } from '../models/ILinkProps';
import { isNullOrEmpty } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';

export class LinksStore extends StoreBase {
	static componentKey: 'links' = 'links';

	@computed
	get configuration(): ILinksConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(LinksStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}

	@computed
	get show(): boolean {
		const display = this.configuration && this.configuration.display || 'always';
		if (display === 'has-all-selections') {
			return this.storeContext &&
				this.storeContext.selectionStore &&
				this.storeContext.selectionStore.hasAllSelections;
		}
		return true;
	}

	@computed
	get links(): ILinkProps[] {
		const { appStore } = this.storeContext;
		const linksConfig = this.configuration && this.configuration.links;

		if (!isNullOrEmpty(linksConfig)) {
			return linksConfig.map((linkConfig) => {
				const { text, target, redirect } = linkConfig;
				const href = appStore.getRedirectPath(redirect) || '';
				return { text, target, href };
			});
		}

		return [];
	}
}